// src/services/imageService.js
import { PROCESS_IMAGES_LB } from '../components/pages/config';
import { FIND_GUEST_API } from '../components/pages/config';


/**
 * Upload images to the "process images" service behind an ALB.
 */
export async function uploadImages(user_id, event_id, fileList, batchSize = 15) {
  const total = fileList.length;
  for (let i = 0; i < total; i += batchSize) {
    const batch = fileList.slice(i, i + batchSize);

    const formData = new FormData();
    formData.append('user_id', user_id);
    formData.append('event_id', event_id);

    for (let file of batch) {
      formData.append('files', file);
    }

    const response = await fetch(`https://api.heyi.co.il/api/upload_images`, {
      method: 'POST',
      body: formData
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Error uploading images batch starting at index ${i}`);
    }

    const result = await response.json();
  }


}



/**
 * בקשת תמונות לאירוע (תומך paging)
 * @param {string}  event_id   – מזהה אירוע
 * @param {number}  limit      – כמה תמונות להביא (0 = הכול)
 * @param {number}  offset     – לדלג על כמה (0 = מתחיל מההתחלה)
 * @param {string}  url_type   – 'small' / 'origin'
 * @returns {Promise<Array>}   – מערך תמונות
 *
 * דוגמאות:
 *   // 1) כמו פעם – כל התמונות
 *   const all = await getImages(evId);
 *
 *   // 2) 50 ראשונות
 *   const first50 = await getImages(evId, 50);
 *
 *   // 3) 50 הבאות (offset = 50)
 *   const next50  = await getImages(evId, 50, 50);
 */
export async function getImages(event_id, limit=0, offset=0, url_type="small") {
  const url = new URL(`${FIND_GUEST_API}/get-event-images`);
  url.searchParams.append("event_id", event_id);
  url.searchParams.append("url_type", url_type);
  if (limit  > 0) url.searchParams.append("x",      String(limit));
  if (offset > 0) url.searchParams.append("offset", String(offset));

  const res = await fetch(url);
  if (!res.ok) {
    // אפשר להדפיס שגיאה אבל עדיין להחזיר מבנה עקבי
    console.error("getImages failed", await res.text());
    return { images: [], total: 0 };
  }

  const data = await res.json().catch(() => ({}));
  return {
    images: Array.isArray(data.images) ? data.images : [],
    total : Number(data.total) || 0
  };
}




/**
 * Remove an image by image_id.
 * Adjust `YOUR_DELETE_IMAGE_API` to point at your actual DELETE endpoint:
 *   DELETE https://your-api.com/delete-image?image_id=IMG123
 */
export async function removeImage(image_id) {
  const url = new URL(`${FIND_GUEST_API}/delete-image`);
  url.searchParams.append('image_id', image_id);

  const response = await fetch(url, { method: 'DELETE' });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Error removing image');
  }
  return response.json();
}



/**
 * findGuestImages: 
 * Uploads a guest image to the backend to find matching event images.
 *
 * @param {string} event_id - The event ID 
 * @param {File} guestFile - The user’s guest image file 
 * @param {string} guest_id - A unique ID for the guest
 * @returns {Array<Object>} - Array of matched image URLs
 */
export async function findGuestImages(event_id, guestFile, guest_id) {
  if (!(guestFile instanceof File)) {
    throw new Error("Invalid file");
  }

  const fileBuffer = await guestFile.arrayBuffer();

  const response = await fetch(`${FIND_GUEST_API}/find-guest-images`, {
    method: "POST",
    headers: {
      "Content-Type": "application/octet-stream",
      "x-event-id": String(event_id),
      "x-guest-id": String(guest_id)
    },
    body: fileBuffer
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Error finding guest images");
  }

  return data.presigned_urls || [];
}


export async function getImagesCount(event_id) {
  const url = new URL(`${FIND_GUEST_API}/get-event-images`);
  url.searchParams.append("event_id", event_id);
  url.searchParams.append("count_only", "1");

  const res = await fetch(url);
  if (!res.ok) throw new Error("count fetch failed");
  const { total } = await res.json();
  return total || 0;
}

